/**
 * 全文检索
 * 2019-10-25
 */
"use strict";
angular.module("fullSearchModule", ["fullSearchRouter", "explosionManageServiceModule"]).
controller("fullSearchCtrl", ["$scope", "$state", '$location', "$q", "httpService", '$filter', '$sce', 'localStorageService', 'modalDialog', 'explosionManageService', function($scope, $state, $location, $q, httpService, $filter, $sce, localStorageService, modalDialog, explosionManageService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            copyCurrPage: 1,
            tabs: [
                {
                    name: '个人稿库',
                    value: '0,0',
                    total: 0
                },
                {
                    name: '已投稿库',
                    value: '0,1',
                    total: 0
                },
                {
                    name: '报料草稿',
                    value: '1,0',
                    total: 0
                },
                {
                    name: '已推报料',
                    value: '1,1',
                    total: 0
                }
            ],
            // 已选中的tab
            currentTab: {}
        }
        $scope.data = {
            listData: [],
            // 勾选
            selectedArray: []
        };

        $scope.status.pageObj = {
            CURRPAGE: 1,
            PAGESIZE: 20,
            PAGECOUNT: 1,
            ITEMCOUNT: 0
        };
        $scope.page = $.extend({}, $scope.status.pageObj);
        $scope.params = {
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE,
            startTime: $scope.status.startTime,
            endTime: $scope.status.endTime,
            searchWord: $state.params.keywords
        };
        $scope.status.currentTab = $scope.status.tabs[0];
    }
    
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        initParams();
        requestData();
        $scope.$emit('searchWordChange', $state.params.keywords);
    }
    /**
     * [selectPageNum description] 切换每页显示的条数
     * @return {[type]} [description]
     */
    $scope.selectPageNum = function() {
        $scope.params.currPage = $scope.page.CURRPAGE;
        $scope.params.pageSize = $scope.page.PAGESIZE;
        $scope.status.copyCurrPage = 1;
        requestData();
    };
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.params.currPage = $scope.page.CURRPAGE;
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };
    /**
     * [jumpToPage description:跳转指定页面]
     */
    $scope.jumpToPage = function jumpToPage() {
        if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.params.currPage = $scope.status.copyCurrPage;
        $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        requestData();
    }

    // 切换 tab
    $scope.checkTab = function(item) {
        $scope.status.currentTab = item;
        $scope.data.listData = [];
        $scope.page = $.extend({}, $scope.status.pageObj);
        initParams();
        requestData();
    }

    // 设置参数
    function initParams() {
        $scope.params.currPage = 1;
        var statusAdnType = $scope.status.currentTab.value.split(',');
        $scope.params.articleStatus = statusAdnType[1];
        $scope.params.articleType = statusAdnType[0];
    }

    // 检索请求
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/article/retrieve.do", $scope.params, "get").then(function(data) {
            $scope.data.listData = data.data.ldata.map(item => {
                ['picUrlList', 'videoUrlList', 'audioUrlList'].forEach(function (arr) {
                    item[arr] = item[arr] ? item[arr].map(v => angular.isObject(v) ? v.url : v) : [];
                });
                return item;
            });
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages3
            };
        });
        // 获取每种分类的总条数
        $scope.loadingPromise = httpService.http('/mcnww/web/article/statisticsCategoryNum.do', $scope.params, 'get').then(function(res) {
            let types = res.data.reduce((cur, next) => {
                let k = next.articleType + ',' + next.articleStatus;
                cur[k] = next.amount;
                return cur;
            }, {});
            $scope.status.tabs.forEach(item => {
                item.total = types[item.value] || 0;
                return item;
            });
        });
    }
    // 展示全文
    $scope.handleArticleContent = function(item) {
        var contentArray = item.articleHtmlCon.split(/\n/);
        for (var i = contentArray.length - 1; i >= 0; i--) {
            var content = contentArray[i];
            if (content === "") {
                contentArray.splice(i, 1);
            } else {
                content = content.replace(/ /g, "&nbsp;");
                contentArray[i] = "<p>" + content + "</p>";
            }
        }
        item.articleContentCopy = $sce.trustAsHtml(contentArray.join(""));
    };
    // 时间选择
    $scope.queryByDropdown = function() {
        $scope.params.startTime = $scope.status.startTime;
        $scope.params.endTime = $scope.status.endTime;
        $scope.params.currPage = 1;
        requestData();
    };
    // 全选
    $scope.selectPanel = function () {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    }
    // 勾选
    $scope.selectDoc = function (item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    }
    // 投稿
    $scope.submission = function() {
        var ids = $scope.data.selectedArray.map(function (item) {
            return item.id
        }).join(',');
        httpService.http("/mcnww/web/article/contribute.do", {ids: ids}, "get").then(function(data) {
            modalDialog.success("投稿成功", "success", false, function() {});
            $scope.data.selectedArray = [];
            requestData();
        });
    };
    // 删除稿件
    $scope.deleteArticle = function() {
        modalDialog.confirmModal("删除", "确认删除选中稿件吗？", function() {
            var ids = $scope.data.selectedArray.map(function (item) {
                return item.id
            }).join(',');
            httpService.http("/mcnww/web/article/delete.do", {ids: ids}, "get").then(function(data) {
                $scope.data.selectedArray = [];
                requestData();
            });
        });
    };
    // 编辑爆料
    $scope.editTipOff = function(item) {
        explosionManageService.createExplosion($scope.status, item).then(function(data) {
            requestData();
        });
    }
    // 发布爆料
    $scope.publish = function () {
        modalDialog.confirmModal("发布", "确认发布选中报料吗？", function() {
            var ids = $scope.data.selectedArray.map(function (item) {
                return item.id
            }).join(',');
            httpService.http("/mcnww/web/article/contribute.do", {
                ids: ids
            }, "get").then(function() {
                modalDialog.success('发布成功', 'info');
                $scope.data.selectedArray = [];
                $scope.status.copyCurrPage = 1;
                jumpToPage();
            });
        });
    };
    // 删除爆料
    $scope.deleteList = function () {
        modalDialog.confirmModal("删除", "确认删除选中报料吗？", function() {
            var ids = $scope.data.selectedArray.map(function (item) {
                return item.id
            }).join(',');
            httpService.http("/mcnww/web/article/delete.do", {ids: ids}, "get").then(function() {
                modalDialog.success('删除成功', 'info');
                $scope.data.selectedArray = [];
                $scope.status.copyCurrPage = 1;
                jumpToPage();
            });
        });
    };
}])
.controller('fullSearchModuleCtrl', ['$scope', function($scope) {
    $scope.$on('searchWordChange', function(event, v) {
        $scope.$broadcast('changeHeadKeyWord', v);
    });
}]);
